<template>
    <div class="epf-filter">
        <div class="epf-filter__container" :class="background">
            <div class="container">
                <epf-filter-checkboxes :filter-config="filterAvailability"/>
            </div>
            <div class="container">
                <div class="row">
                    <epf-filter-select v-if="filterDicke" :filter-config="filterDicke" class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-select v-if="filterFormat" :filter-config="filterFormat" class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-select v-if="filterApplication" :filter-config="filterApplication" class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-decor v-if="filterDekor" :filter-config="filterDekor" class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-product v-if="filterProdukt" :filter-config="filterProdukt" class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-select v-if="filterStruktur" :filter-config="filterStruktur" class="col-12 col-md-4 col-lg-3"/>
                    <epf-filter-select-with-input v-if="filterMatnr" :filter-config="filterMatnr" class="col-12 col-md-4 col-lg-3"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import EpfFilterSelect from '@epf/components/epf-filter-select/epf-filter-select';
import EpfFilterButtons from '@epf/components/epf-filter-buttons/epf-filter-buttons';
import EpfFilterDecor from '@epf/components/epf-filter-decor/epf-filter-decor';
import SalAccordion from '@productfinder/components/sal-accordion/sal-accordion';
import GlobalAccordion from '@global/global-elements/global-accordion/global-accordion';
import GlobalButton from "../../../../../../global/global-elements/global-button/global-button";
import EpfFilterProduct from '@epf/components/epf-filter-product/epf-filter-product';
import EpfFilterCheckboxes from "@epf/components/epf-filter-checkboxes/epf-filter-checkboxes.vue";
import EpfFilterSelectWithInput from "@epf/components/epf-filter-select-with-input/epf-filter-select-with-input.vue";

export default {
    name: "EpfFilter",
    components: {
        EpfFilterSelectWithInput,
        EpfFilterCheckboxes,
        EpfFilterProduct,
        GlobalButton, GlobalAccordion, SalAccordion, EpfFilterDecor, EpfFilterButtons, EpfFilterSelect
    },
    props: {},
    computed: {
        ...mapState(['config', 'showFilters']),
        background() {
            if (this.showFilters) {
                return 'light';
            }
            return '';
        },

        filterAvailability() {
            return this.$store.getters.filterByName('availability');
        },
        filterDicke() {
            return this.$store.getters.filterByName('dicke');
        },
        filterApplication() {
            return this.$store.getters.filterByName('recommended_application');
        },
        filterFormat() {
            return this.$store.getters.filterByName('format');
        },
        filterDekor() {
            return this.$store.getters.filterByName('decor');
        },
        filterProdukt() {
            return this.$store.getters.filterByName('product');
        },
        filterStruktur() {
            return this.$store.getters.filterByName('struktur');
        },
        filterMatnr() {
            return this.$store.getters.filterByName('matnr');
        }
    },
    methods: {
        ...mapActions(['toggleFilters']),
    }
}
</script>
